/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

angular.module('bulbApp.modalModule')
.service('BulbCoppaModalService', ['$cookies', '$translate', '$window', 'BulbBusyService', 'BulbModalService', 'Restangular', BulbCoppaModalService]);

/**
 * BulbCoppaModalService is used to show the modal for Parent Consent Form
 * for the STUDENTS below the age of 13.
 */
function BulbCoppaModalService($cookies, $translate, $window, BulbBusyService, BulbModalService, Restangular) {

  var that = this;

  /**
   * Custom modal with form input to send instructions to a parent or guardian
   */
  this.showCOPPAactionModal = function () {
    //pointing intentionally outside of the scope of this method for dom manipulation
    that.submitBtnPrimary = jQuery('#submitBtnPrimary');
    that.submitBtnPrimary.prop( 'disabled', true);
    that.submitBtnPrimary.prop( 'innerText', $translate.instant('button_submitted'));
    BulbModalService.show({
      templateUrl: 'ajs/components/modal/coppamodal/coppamodal.html',
      titleCode: 'coppa_underaged_user_modal_title',
      controller: ['$scope', 'BulbErrorService', function($scope, BulbErrorService) {
        let coppaModal = this;
        coppaModal.consentLink = `https://assets.bulbapp.com/bulbParentConsentForm2018${$cookies.get('language') === 'pt' ? '-PT' : ''}.pdf`;

        $scope.$on('$destroy', function() {
          $window.location = '/';
        });

        coppaModal.emailSent = function() {
          let button = jQuery('#coppaModalSubmit');
          button.prop( 'disabled', true );
          button.prop( 'innerText', $translate.instant('button_submitted'));
        };

        coppaModal.sendCOPPAEmail = function(email) {
          BulbBusyService.showBusyDuring(
            Restangular.one('/accounts/coppaEmail/').customPOST({email: email, language: $cookies.get('language')})
              .then(function(response) {
                if (response) {
                  BulbErrorService.showError(null, response);
                } else {
                  coppaModal.emailSent();
                }
              })
          );
        };

        coppaModal.submit = function () {
          if (coppaModal.form && coppaModal.form.email !== null) {
            coppaModal.sendCOPPAEmail(coppaModal.form.email);
            $window.location = '/';
          }
        };
      }],
      controllerAs: 'coppaModalCtrl',
      showCancelButton: false,
      showOkButton: false,
      closeOnClick: false
    });
  };
}


